import $ from 'jquery';
import axios from 'axios';
/**
 * Soumission du formulaire de connexion Neosafe
 * @param e
 */
const submit = (e) => {
    e.preventDefault();
    const $alert_bad_login = $("#alert-bad-login"),
        $alert_error = $("#alert-error"),
        $form_wrapper = $('#the-form-wrapper'),
        $sucess_message = $('#success-redirect-message'),
        $form = $(e.currentTarget),
        $password_field = $("#neosafe_password"),
        $btn_submit = $('#submit-neosafe-btn'),
        user_email = $("#neosafe_email").val(),
        user_password = $password_field.val(),
        bodyFormData = new FormData();
    bodyFormData.append('neosafe_email', user_email);
    bodyFormData.append('neosafe_password', user_password);
    $alert_bad_login.hide();
    $alert_error.hide();
    $btn_submit.attr("disabled", true);
    axios.post($form.attr("action"), bodyFormData)
        .then((response) => {
            if (response.data.success) {
                $form_wrapper.hide();
                $sucess_message.show();
                window.open(response.data.location, "_self");
            } else {
                $alert_bad_login.show();
                $password_field.val("").focus();;
            }
        })
        .catch(() => $alert_error.show())
        .finally(() => $btn_submit.removeAttr("disabled"));
}

export {submit};